const updateProps = (state, { props }) => ({
  ...state,
  ...props
});

export default updateProps;
